// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyMessage_container__3kWjW"};